(function () {
  'use strict';

  angular
    .module('trainingCostReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('trainingCostReport', {
        url: '/training-cost-report',
        views: {
          'trainingCostReportView': {
            templateUrl: 'training-cost-report/views/training-cost-report.tpl.html',
            controller: 'TrainingCostReportCtrl',
            controllerAs: 'trainingCostReport'
          }
          }
      });
  }
}());
